import { call, put, takeLatest , select } from 'redux-saga/effects';

import ApiRouts from '../../api/routes';
import {DELETE} from "../../api";
import {
    FETCH_DISLIKE, FETCH_DISLIKE_COLLECTION, FETCH_PRODUCT_LIST,
    FETCH_SHOW_MORE_COLLECTION_LIST,
    SET_DISLIKE,
    SET_DISLIKE_COLLECTION,
} from "../actions";
import {useDispatch} from "react-redux";


const getDislikeCollectionId = (state) => state.likeCollectionId;



export function* FetchDislikeCollectionSaga() {


    const dislikeCollectionId = yield select(getDislikeCollectionId);


    try {
        const response = yield call(DELETE, `${ApiRouts.API_LIKE_Collection}/${dislikeCollectionId}`);

        if (response) {

            yield put({
                type:SET_DISLIKE_COLLECTION,
                payload:response.data.data
            });

            yield put({ type: FETCH_PRODUCT_LIST });
            yield put({ type: FETCH_SHOW_MORE_COLLECTION_LIST });


        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {

        if(error.response.status === 401){
            localStorage.removeItem('edexLicenceToken');
        }

        // yield put(setError(error.message));  // Set error if something goes wrong
        // yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* dislikeCollectionSaga() {
    yield takeLatest(FETCH_DISLIKE_COLLECTION, FetchDislikeCollectionSaga);
}

export default dislikeCollectionSaga;
